export enum TagType {
	BYTE = 1, // 8-bit unsigned integer.
	ASCII = 2, // 8-bit byte that contains a 7-bit ASCII code; the last byte must be NUL (binary zero).
	SHORT = 3, // 16-bit (2-byte) unsigned integer.
	LONG = 4, // 32-bit (4-byte) unsigned integer.
	RATIONAL = 5, // Two LONGs: the first represents the numerator of a fraction; the second, the denominator.
	SBYTE = 6, // An 8-bit signed (twos-complement) integer.
	UNDEFINED = 7, // An 8-bit byte that may contain anything, depending on the definition of the field.
	SSHORT = 8, // A 16-bit (2-byte) signed (twos-complement) integer.
	SLONG = 9, // A 32-bit (4-byte) signed (twos-complement) integer.
	SRATIONAL = 10, // Two SLONG’s: the first represents the numerator of a fraction, the second the denominator.
	FLOAT = 11, // Single precision (4-byte) IEEE format.
	DOUBLE = 12, // Double precision (8-byte) IEEE format.
}

export const TagSize: Record<TagType, number> = {
	[TagType.BYTE]: 1,
	[TagType.ASCII]: 1,
	[TagType.SHORT]: 2,
	[TagType.LONG]: 4,
	[TagType.RATIONAL]: 8,
	[TagType.SBYTE]: 1,
	[TagType.UNDEFINED]: 1,
	[TagType.SSHORT]: 2,
	[TagType.SLONG]: 4,
	[TagType.SRATIONAL]: 8,
	[TagType.FLOAT]: 4,
	[TagType.DOUBLE]: 8,
}
